'use client'

import { useState, useEffect } from 'react'
import { useAnalyticsConsent } from '@/hooks/useAnalyticsConsent'

/**
 * Component to display a consent banner for analytics tracking
 */
export function ConsentBanner() {
  const { consentGiven, consentShown, giveConsent, denyConsent } = useAnalyticsConsent()
  const [visible, setVisible] = useState(false)

  // Show the banner if consent is unknown (null) and hasn't been shown yet
  useEffect(() => {
    if (consentGiven === null && !consentShown) {
      // Slight delay to avoid showing the banner immediately on page load
      const timer = setTimeout(() => {
        setVisible(true)
      }, 1000)
      
      return () => clearTimeout(timer)
    } else {
      setVisible(false)
    }
  }, [consentGiven, consentShown])

  if (!visible) {
    return null
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-gray-200 shadow-lg">
      <div className="container mx-auto max-w-7xl flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <h3 className="text-lg font-medium">Cookie Consent</h3>
          <p className="text-sm text-gray-600 mt-1">
            We use cookies and similar technologies to help personalize content, enhance your experience, and analyze our traffic. 
            By clicking "Accept", you consent to our use of analytics cookies.
          </p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={denyConsent}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            Decline
          </button>
          <button
            onClick={giveConsent}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}